export const CONTACT_EMAIL_TRUNCATE_LENGTH = 17;
export const CONTACT_BUTTON_TEST_ID = 'contact-button';
